<script setup>
import { computed, ref } from 'vue';
import { getI18nKey } from 'dashboard/routes/dashboard/settings/helper/settingsHelper';
import ShowMore from 'dashboard/components/widgets/ShowMore.vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import webhooksAPI from 'dashboard/api/webhooks';

import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  webhook: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['edit', 'delete']);
const { t } = useI18n();

// Testar: envia um payload de teste pra URL e mostra o status da resposta.
const testing = ref(false);
const testWebhook = async () => {
  testing.value = true;
  try {
    const { data } = await webhooksAPI.test(props.webhook.url);
    if (data.success) {
      useAlert(
        t('INTEGRATION_SETTINGS.WEBHOOK.TEST.SUCCESS', { status: data.status })
      );
    } else {
      useAlert(
        t('INTEGRATION_SETTINGS.WEBHOOK.TEST.FAILED', {
          status: data.status || '—',
        })
      );
    }
  } catch (error) {
    useAlert(t('INTEGRATION_SETTINGS.WEBHOOK.TEST.ERROR'));
  } finally {
    testing.value = false;
  }
};
const subscribedEvents = computed(() => {
  const { subscriptions } = props.webhook;
  return subscriptions
    .map(event =>
      t(
        getI18nKey(
          'INTEGRATION_SETTINGS.WEBHOOK.FORM.SUBSCRIPTIONS.EVENTS',
          event
        )
      )
    )
    .join(', ');
});
</script>

<template>
  <tr>
    <td class="py-4 ltr:pr-4 rtl:pl-4">
      <div class="font-medium break-words text-n-slate-12">
        {{ webhook.url }}
      </div>
      <div class="block mt-1 text-sm text-n-slate-11">
        <span class="font-medium">
          {{ $t('INTEGRATION_SETTINGS.WEBHOOK.SUBSCRIBED_EVENTS') }}:
        </span>
        <ShowMore :text="subscribedEvents" :limit="60" />
      </div>
    </td>
    <td class="py-4 min-w-xs">
      <div class="flex justify-end gap-1">
        <Button
          v-tooltip.top="$t('INTEGRATION_SETTINGS.WEBHOOK.TEST.BUTTON_TEXT')"
          icon="i-lucide-zap"
          slate
          xs
          faded
          :is-loading="testing"
          @click="testWebhook"
        />
        <Button
          v-tooltip.top="$t('INTEGRATION_SETTINGS.WEBHOOK.EDIT.BUTTON_TEXT')"
          icon="i-lucide-pen"
          slate
          xs
          faded
          @click="emit('edit', webhook)"
        />
        <Button
          v-tooltip.top="$t('INTEGRATION_SETTINGS.WEBHOOK.DELETE.BUTTON_TEXT')"
          icon="i-lucide-trash-2"
          xs
          ruby
          faded
          @click="emit('delete', webhook, index)"
        />
      </div>
    </td>
  </tr>
</template>
